


<!-------------------Banner starts------------------------------>
<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center h-100 w-100">

                <img src="../../../assets/images/banners/ouropinion_bannarimage.png"
                    alt="Banner-mit" class="img img-responsive w-100 h-100 d-none d-md-block">

                <!-- Md -->
                <img src="../../../assets/images/banners/ouropinion_mobilebannar.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="ouropinion mobile" />
                <!-- Md -->
                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-md-4 col-sm-12">
                            <div class="banner-section">
                                <div class="align-items-center global_title global_banner_title  title_banner_content futek-title"  role="heading" aria-level="2">
                                    <span>Helping shape social Perspectives</span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-3">
                                    <span> Learn how we built a futuristic application and
                                        incorporated future cloud advances into our client’s
                                        IT infrastructure.</span>
                                </div>
                                <div class="col pt-lg-3 pt-3 mt-lg-3">
                            <a href="contact" class="global_button   text-left col  text-white white_button" aria-label="View Contact Page">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="arrowBlack" /></div>
                            EXPLORE  </a>
                            </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class=" banner-subsection col">
         <h5>Trusted by Global Technology companies</h5>
         </div> -->
    </div>
</div>
<!-------------------Banner ends------------------------------>
<div class="site-wrapper-reveal">
    <div class="vision-overview section-space--pt_100">
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-5">
                <div class="heading global_section_header futeck_mediaquares">Helping exchange social perspectives in a
                    seamless way </div>
            </div>
            <div class="col-lg-5">
                <div class="portfolio-details-content">
                    <div class="text ">
                        <div class="global_section_content futeck_mediaquares">In a consumer-first demographic world,
                            opinion polling helps understand public perceptions and behaviors toward broad-ranging
                            issues. To gauge the different opinions of the public
                            on several topics of interest- Our Opinions had envisioned building a social networking
                            platform where people can connect with each other by asking questions, taking polls,
                            providing their opinion, reading market perspectives, getting product reviews for buying
                            decisions and several other purposes.
                            Our Opinions were to span across various categories like education, entertainment, current
                            events, finance, politics, sports etc. with the capability to expand to various other
                            categories as needed very easily.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>


        <!--====== Casestudy Business Problem and Mit Solution Start ======-->
        <div class="requirements-vision section-space--pt_60">
            <div class="ht-problem-solution casestudy_contentsolution style-01">
                <div class="row">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-5">
                        <div class="label problem-label section-space--mb_50 global_section_header">Business problem
                        </div>
                        <div class=" global_section_content futeck_mediaquares">As opposed to the lengthy complex
                            opinion polling, the
                            client wanted to run their website on a platform that is highly available,
                            scalable, easily maintainable, and globally accessible with minimal platform management
                            overhead. As an insights-driven business, the client wanted a flexible solution with an
                            ecosystem of tools
                            and capabilities that helps them measure and redefine how it serves its members and
                            stakeholders. Along with simplified content management, the client wanted platform with
                            high-end infrastructure
                            security that’s reliable and cost-effective.
                        </div>
                    </div>

                    <div class="col-lg-5">
                        <div class="label solution-label  solution-label1 section-space--mb_50 global_section_header">The MIT Solution </div>
                        <div class="global_section_content futeck_mediaquares pt-0">
                            MIT Resources helped to build a social platform in a modular approach which gives
                                capabilities to add functional modules in an agile methodology to raise questions
                                and polls, share ideas and opinions
                                and learn from other experiences. This platform's modules can be enhanced and
                                configured easily with little efforts. and MIT Resources chose Azure as an
                                    underlying platform to deploy the application code
                                    and leverage Azure PaaS and SaaS capabilities for low maintenance, scalability,
                                    elasticity, and security.MIT chose C sharp and .NET as coding language along
                                    with html and css for frontend and MS SQL as database.
                                    For easy and quick user onboarding signing with LinkedIn, Facebook, gmail etc.
                                    is allowed which allows user to use their existing social media credentials and
                                    there is no need to create new or signup from starting to provide better user
                                    onboarding experience.
                                    MIT Resources leveraged advanced features for security, automation, cloud-native
                                    monitoring, logging, alerting and automated code build and deployment using
                                    Azure DevOps.
                        </div>
                    </div>
                    <div class="col-lg-1"></div>
                </div>

                <!-- <div class="item casestudy_subcontent">
                    <div class="row">
                        <div class="col-md-1"></div>
                        <div class="col-md-5 pt-5">
                          
                        </div>
                        <div class="col-md-5 pt-5">
                            
                        </div>
                        <div class="col-md-1"></div>
                    </div>
                </div> -->
            </div>
            <!--====== Casestudy Business Problem and Mit Solution Start ======-->
            <!--====== Ouropinions architecture Start ======-->
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="global_section_header label solution-label mt-4">Architecture</div>
                </div>
                <div class="col-lg-1"></div>
            </div>

            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="global_section_content pt-5 futeck_mediaquares">
                      Maganti IT Resources deployed the website on Azure PaaS (Platform as a Service) which has
                        mem-cache based browser level caching; Redis-based edge level and API calls to the databases.
                        es. Our Team chose different app service plans and app services for the admin portal, reporting,
                        frontend and Api code base.
                        The application is designed in MVC (Model-View-Control) pattern, with html and css based
                        frontend, having api calls to MS SQL based backend.
                        Based on the feedback, the team is planning to introduce more such environments and have
                        additional advanced features like Data Analytics, Artificial intelligence, and machine learning.
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
        <!--====== Ouropinions architecture Start ======-->
    </div>
</div>


<!--====== Casestudies Accordtion and Image Start ======-->
<div class="rowsizes">
    <div class="casestudy_accordtionbgcolor mt-5">
        <div class="global_section_header text-center mt-3">Client Benefits </div>
        <div class="global_section_content text-center">By leveraging our Maganti IT services, the client has witnessed
            benefits such as development of better product at lower cost,</div>
        <div class="global_section_content text-center mb-5"> Improvement in Speed to Market, Cost Reduction enabling
            accelerated business growth and efficiency.</div>
            <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-5">
            
            <div class="container-fluid">
                <div class="accordion_container ouropinions_accordtionsection">
                    <div *ngFor="let item of accordionItems; let i = index">
                      <div class="accordion_head ouropinions_accordtionheading" (click)="toggleAccordion(i)" aria-haspopup="true" tabindex="0" role="button">
                        {{ item.title }}
                        <span class="plusminus">{{ isOpen[i] ? '-' : '+' }}</span>
                      </div>
                      <div class="accordion_body ouropinion_bodysection" *ngIf="isOpen[i]">
                        <div class="global_section_content ouropinion_subcontent">
                          {{ item.content }}
                        </div>
                      </div>
                    </div>
                  </div>
                  
            </div>
        </div>
        <div class="col-lg-5">
            <img src="../../../assets/images/ouropinionsimages/clientbenifits.png"
                alt="client-benifits" class="casestudy_videoimage benifits_image">
        </div>
        <div class="col-lg-1"></div>
    </div>
    </div>
</div>
<!--====== Casestudies Accordtion and Image End ======-->

<!--====== Casestudies Results Section Start ======-->

<div class="feature-icon-wrapper  benefits_bgimage section-space--ptb_60 ">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title-wrap text-center section-space--mb_20">
                    <h3 class="manufacture-heading global_section_header mb-5">Results</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="feature-list__three">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <img src="../../../assets/images/ouropinionsimages/agilecloud.png"
                                                    alt="Agile-Cloud" class="w-100 h-100">
                                            </div>
                                            <div class="heading">
                                                Agile Cloud
                                            </div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Quickly respond to evolving
                                                business scenarios with agile cloud onboarding.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <img src="../../../assets/images/ouropinionsimages/strategicchanges.png"
                                                    alt="Strategic-Changes" class="w-100 h-100">
                                            </div>
                                            <div class="heading">
                                                Strategic Changes
                                            </div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Implement rapid changes in
                                                organizational strategies with agile technology.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <img src="../../../assets/images/ouropinionsimages/businessintelligence.png"
                                                    alt="Omnichannel-Devices" class="w-100 h-100">
                                            </div>
                                            <div class="heading">Omnichannel Devices</div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Gain anytime, anywhere business
                                                intelligence with omnichannel devices.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <img src="../../../assets/images/ouropinionsimages/connectecosystem.png"
                                                    alt="connected-ecosystem" class="w-100 h-100">
                                            </div>
                                            <div class="heading">Connected Ecosystem</div>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Improve deployment lead yime
                                                through a connected ecosystem of stakeholders.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

